export default "__VITE_ASSET__644e59f1__"